namespace $.$$ {
	export class $shm_hitalama_form_submit extends $.$shm_hitalama_form_submit {

		private pending?: Promise< unknown >
		private disposed = false

		@ $mol_action
		event_activate( event: Event ) {
			if( !event || this.pending || !this.enabled() ) return
			$mol_wire_sync( this ).activate_start( event )
		}

		activate_start( event: Event ) {
			// A render must not own and cancel the command when the form closes.
			const pending: Promise< unknown > = $mol_wire_async( this ).activate_command( event ).then()
			this.pending = pending
			this.status( [ pending ] )
			pending.then(
				()=> {
					this.pending = undefined
					if( !this.disposed ) this.status( [ null ] )
				},
				( error: unknown )=> {
					this.pending = undefined
					if( !this.disposed ) this.status( [ error ] )
				},
			)
		}

		activate_command( event: Event ) {
			this.event_click( event )
			return this.click( event )
		}

		destructor() {
			this.disposed = true
			super.destructor()
		}
	}
}
